import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined'
import { useTranslation } from 'react-i18next'
import {
  getFormattedKm,
  getFormattedOptionAmount,
  getFormattedReconditioningEstCost,
  mapLocation,
} from 'lib/carDetailsLib'

import CarSpecification from './CarSpecification'

const classes = {
  carSpecifications: 'car-specifications',
}
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.carSpecifications}`]: {
    display: 'flex',
  },
}))

export default function CarSpecifications({ car }) {
  const { t } = useTranslation()

  return (
    <Root className={classes.carSpecifications}>
      <div>
        <CarSpecification
          icon={SpeedOutlinedIcon}
          value={getFormattedKm(car.km)}
        />
        <CarSpecification icon={CalendarTodayOutlinedIcon} value={car.year} />
      </div>
      <div>
        <CarSpecification
          icon={LocationOnOutlinedIcon}
          value={mapLocation(car.location)}
        />
        <CarSpecification
          icon={LocalGasStationOutlinedIcon}
          value={car.fuelType}
        />
      </div>
      <div>
        <CarSpecification
          icon={AccountTreeOutlinedIcon}
          value={t(`carDetails.mapping.${car.transmission}`)}
        />
        <CarSpecification icon={DirectionsCarOutlinedIcon} value={car.plate} />
      </div>
      <div>
        <CarSpecification
          icon={KeyboardDoubleArrowDownIcon}
          value={getFormattedReconditioningEstCost(car.reconditioningEstCost)}
          sx={{ pr: 0 }}
        />
        <CarSpecification
          icon={DiamondOutlinedIcon}
          value={getFormattedOptionAmount(car.optionAmount)}
          sx={{ pr: 0 }}
        />
      </div>
    </Root>
  )
}

CarSpecifications.propTypes = {
  car: T.object.isRequired,
}
